<div class="bank-account_scroll" *ngIf="!loading && !isError">
  <div class="bank-account">
    <div class="header">
      <ion-text class="title">Ingresa tus datos bancarios</ion-text>
      <ion-text class="sub-title"
        >Agrega la cuenta en donde quieres recibir tu pensión</ion-text
      >
    </div>

    <div class="login-container">
      <form class="form-container" [formGroup]="form">
        <div class="bank-dropdown-wrapper">
          <app-dropdown [label]="label" [options]="bancos" formControlName="codigoInstitucionFinanciera"
            (changeEmitter)="seleccionBanco($event)" [value]="value"></app-dropdown>
        </div>

        <div class="label-float-select mt-0">
          <p class="subtitle">Selecciona un tipo de cuenta</p>
          <ion-chip
            *ngFor="let item of tipoCuentas; let i = index"
            role="button"
            tabindex="0"
            [outline]="item.seleccionado"
            (click)="seleccionarCuenta(item.idTipoCuenta)"
            (keydown.enter)="seleccionarCuenta(item.idTipoCuenta)"
          >
            {{ item.nameTipoCuenta }}
          </ion-chip>
        </div>

        <div class="container-input">
            <input
              id="numeroCuenta"
              class="form-input"
              inputmode="numeric"
              type="numeric"
              placeholder=" "
              formControlName="numeroCuenta"
              (keypress)="validateInput($event)"
              (paste)="pastePrevent($event)"
              onContextMenu="return false;"
              onPaste="return false;"
              [maxlength]="18"
              (ngModelChange)="onChange($event)" 
              required
              [readonly]="isCuentaRut"
            />
            <label class="form-label" for="numeroCuenta">Ingresa un número de cuenta</label>
          </div>

        <div *ngIf="isCheckLegal" class="info-checkLegal">
          <div class="info-checkLegal__check">
            <ion-checkbox
              slot="start"
              formControlName="checkLegal"
              (keydown.enter)="enterCheckLegal()"
            ></ion-checkbox>
          </div>
            <ion-label class="label-checkLegal"
              >Declaro que la cuenta ingresada está a mi nombre y es
              unipersonal</ion-label
            >
        </div>

        <div>
          <ion-text class="text-item tex-bold color-dark">
            Ten en cuenta que:
          </ion-text>
          <ul>
            <ion-text *ngIf="isCuentaRut" class="text-item color-dark">
              <li>
                Para la Cuenta Rut de Banco Estado, el depósito puede ser rechazado si es mayor a $4.000.000 mensuales o si tu saldo en la cuenta es mayor a $5.000.000.
              </li>
            </ion-text>
            <ion-text class="text-item color-dark">
              <li>
                Debes ingresar una cuenta unipersonal que esté a tu nombre.
              </li>
            </ion-text>
          </ul>
        </div>

        <div class="action-container">
          <button class="b-btn s-button" (click)="exit()">Salir</button>
          <button
            class="b-btn p-button"
            [disabled]="isInvalidForm || isLoading"
            (click)="continue()"
          >
            Continuar
            <ion-spinner
              name="crescent"
              slot="end"
              *ngIf="isLoading; else noLoading"
              color="light"
            ></ion-spinner>
            <ng-template #noLoading>
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </ng-template>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- SKELETON -->

<div class="bank-account_scroll" *ngIf="loading && !isError">
  <div class="bank-account">
    <ion-skeleton-text
      animated
      style="width: 100%; height: 30px; border-radius: 12px"
    ></ion-skeleton-text>

    <div class="login-container">
      <form class="form-container" [formGroup]="form">
        <div class="label-float-select">
          <ion-skeleton-text
            animated
            style="width: 100%; height: 30px; border-radius: 12px"
          ></ion-skeleton-text>
        </div>

        <div class="label-float-select">
          <ion-skeleton-text
            animated
            style="width: 100%; height: 30px; border-radius: 12px"
          ></ion-skeleton-text>
          <ion-skeleton-text
            animated
            style="width: 100%; height: 30px; border-radius: 12px"
          ></ion-skeleton-text>
        </div>

        <div class="label-float">
          <ion-skeleton-text
            animated
            style="width: 100%; height: 30px; border-radius: 12px"
          ></ion-skeleton-text>
          <ion-skeleton-text
            animated
            style="width: 100%; height: 30px; border-radius: 12px"
          ></ion-skeleton-text>
        </div>

        <div class="info-checkLegal">
          <ion-skeleton-text
          animated
          style="width: 100%; height: 30px; border-radius: 12px"
        ></ion-skeleton-text>
        </div>

        <div class="buttons">
          <div class="btn-content">
            <ion-skeleton-text
              animated
              style="width: 100%; height: 30px; border-radius: 12px"
            ></ion-skeleton-text>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<app-generic-error 
*ngIf="isError"
[ops]="errorOps" 
[retryAttempt]="attempt" 
(retryEvent)="onRetryEvent()"
(goToEvent)="onGoToEvent()">
</app-generic-error>